export default "__VITE_ASSET__CCdoh1CE__"